import { Point } from "highcharts";
import { ProcessedHistoryData } from "@/store/budgets/selectors/details-drawer/budgetDetailsHistoryProcessedDataSelector";
import { money } from "@/utils/numeral/money";

export const getBudgetDetailsHistoryChartTooltipValueGetter = (
  processedData?: ProcessedHistoryData[],
) => {
  return (point: Point) => {
    const date = point?.category;
    const index = point?.index ?? 0;
    const data = processedData?.at(index);

    return `
      <div style="min-width: 210px">
        <div style="font-size: 13px; color: #666; margin-bottom: 8px">
            ${date}
        </div>  
        
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px">
          <span
            style="
              display: flex;
              align-items: center;
              font-size: 11px;
              margin-right: 16px;
            "
          >
            <span
              style="font-weight: 400; font-size: 12px; word-break: break-word; white-space: normal; color: #000"
            >
              Used
            </span>
          </span>
          
          <div
            style="display: flex; flex-direction: row; align-items: center"
          >
            <span style="font-weight: 500; font-size: 12px; margin-right: 4px">
              ${money(data?.used)}
            </span>
          </div>
        </div>
        
        <div style="display: flex; justify-content: space-between; align-items: center">
          <span
            style="
              display: flex;
              align-items: center;
              font-size: 11px;
              margin-right: 16px;
            "
          >
            <span
              style="font-weight: 400; font-size: 12px; word-break: break-word; white-space: normal; color: #000"
            >
              Budget
            </span>
          </span>
          
          <div
            style="display: flex; flex-direction: row; align-items: center"
          >
            <span style="font-weight: 500; font-size: 12px; margin-right: 4px">
              ${money(data?.budget)}
            </span>
          </div>
        </div>
      </div>
    `;
  };
};
